import React, { useCallback, useEffect, useRef } from 'react';

import transactionsRegistry from 'src/services/transactions/transactions-registry';
import { IRegistryTransaction } from 'src/services/transactions/types';
import notificationsRegistry from 'src/services/notifications/notifications-registry';
import TransactionStatusNotification from 'src/features/common/collectible/components/transaction-status-notification';
import { IRegistryNotification, NotificationTypeEnum } from 'src/services/notifications/types';

export const NftTransactionStatusContainer: React.FC<{ nftId: string; }> = ({ nftId }) => {
    const notificationRef = useRef<IRegistryNotification>();

    const handleTransactions = useCallback((transactions: IRegistryTransaction[]) => {
        const pendingTransaction = transactions.find(tr => (
            (tr.token.id === nftId) && !tr.isDeleted
        ));

        if (pendingTransaction) {
            notificationRef.current && notificationRef.current?.remove?.();
            notificationRef.current = notificationsRegistry.add({
                component: (props) => <TransactionStatusNotification {...props} nft={pendingTransaction.token} />,
                timeout: 0,
                type: NotificationTypeEnum.info,
                closable: false
            });
        }
    }, [nftId]);

    useEffect(() => {
        handleTransactions(transactionsRegistry.getAll());

        if (nftId) {
            transactionsRegistry.subscribe(handleTransactions);
        }
        return () => {
            transactionsRegistry.unsubscribe(handleTransactions);
        };
    }, [nftId, handleTransactions]);

    useEffect(() => () => {
        notificationRef.current && notificationRef.current?.remove?.();
    }, []);

    return null;
};
